import { apiFetch } from '@/lib/api';

export interface Bucket { count: number }
export interface StatusBucket extends Bucket { status: string }
export interface TypeBucket extends Bucket { type_id: number; label: string }
export interface InvestorBucket extends Bucket { investor: string }
export interface TopicsStats {
  total: number;
  recent_30d: number;
  by_status: StatusBucket[];
  by_type: TypeBucket[];
  by_investor: InvestorBucket[];
}

export function getTopicsStats(): Promise<TopicsStats> {
  return apiFetch<TopicsStats>('/topic-admin/stats');
}
